import { Link } from "react-router-dom";
import { galleryItems } from "@/mocks/site";

export default function GallerySection() {
  return (
    <section className="bg-background-50">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {galleryItems.map((item) => (
          <Link
            key={item.id}
            to="/work"
            className="group relative block aspect-[4/3] overflow-hidden"
            aria-label={`View ${item.title}`}
          >
            <img
              src={item.image}
              alt={item.alt}
              title={`${item.title} — video production`}
              className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
            />
            <div className="absolute inset-0 bg-foreground-950/0 transition-colors duration-300 group-hover:bg-foreground-950/45" />
            {item.award && (
              <span className="absolute left-4 top-4 rounded-full bg-accent-500 px-3 py-1 font-label text-[10px] tracking-[0.15em] uppercase text-accent-950 opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                {item.award}
              </span>
            )}
            <div className="absolute inset-x-0 bottom-0 translate-y-3 p-5 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
              <p className="font-heading text-lg text-background-50">{item.title}</p>
              <p className="mt-1 font-label text-[11px] tracking-[0.18em] uppercase text-background-100/80">
                {item.category} · {item.location}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}